import { getDecodedInstance } from '../getDecodedInstance/getDecodedInstance';
export function isDemoMode(_ref) {
  var _getDecodedInstance;
  let {
    wixCodeApi,
    appParams
  } = _ref;
  return !!((_getDecodedInstance = getDecodedInstance({
    wixCodeApi,
    appParams
  })) != null && _getDecodedInstance.demoMode);
}
//# sourceMappingURL=isDemoMode.js.map